export default {
    'disabled': 'Gorąca 17 jest aktualnie niedostępna.',
    'errors': {
        reset: 'Wystąpił problem podczas cofania Twoich głosów. Spróbuj ponownie później.',
        vote: 'Wystąpił problem podczas głosowania. Spróbuj ponownie później.'
    },
    'gdpr': 'Nie możesz zagłosować w Gorącej 17, ponieważ nie zaakceptowałeś naszej {0}',
    'privacy-policy': 'polityki prywatności.',
    'soon': 'Kolejna edycja Gorącej 17 już niedługo!',
    'undo-vote': 'Cofnij swój głos',
    'vote': 'Głosuj'
}
